import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<h3>Печать фотографий на холсте – это модно и современно!</h3><p>Обыкновенное изображение, напечатанное на холсте, станет стильным дизайнерским предметом! Ваши любимые фотографии на холсте заиграют по-новому, создадут особенную, неповторимую атмосферу помещения, подчеркнут вашу индивидуальность и чувство стиля.</p><p>Также фотопечать на холсте – это отличный подарок, который подойдет для оформления жилых помещений, офисов или кафе в классическом или современном стиле.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
